import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SendIcon from "@mui/icons-material/Send";
import { LuUserPlus } from "react-icons/lu";
import { FaRegUser } from "react-icons/fa6";
import { GoPlus } from "react-icons/go";
import { AiOutlineClose } from "react-icons/ai";
import { FaRegCopy } from "react-icons/fa";
import { IoIosClose } from "react-icons/io";
import "./customer.scss";
import { fetchVehicle } from "../../store/slices/Vehicle/thunk";
import CUSTOMERIDIMAGE from "../../assets/71dfd03e2bc3d97ab6e9d15c83ddcf00.jpg";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  IconButton,
  Chip,
  Button,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { deleteCustomer, fetchCustomer } from "../../store/slices/thunk";
import { useNavigate } from "react-router-dom";
import { MdDelete } from "react-icons/md";
import AddIcon from "@mui/icons-material/Add";
import ConfirmDialog from "../../components/deleteModal";
import Loader from "../../components/loader";
import { toast, ToastContainer } from "react-toastify";
import {
  IoCalendarOutline,
  IoCloseOutline,
  IoSchoolOutline,
  IoSearchOutline,
} from "react-icons/io5";
import AddChild from "../../components/AddChild.tsx/AddChild";
import { getTenantConfigFromStorage } from "../../helpers/tenantConfig";
import { useClientFilter } from "../../Hooks/useClientFilter";
import FilterPopover from "../../components/FilterPopover/FilterPopover";

const CustomerList = () => {
  const [search, setSearch] = useState("");
  const dispatch: any = useDispatch();
  const [getAllCustomer, setAllCustomer] = useState([]);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [totalCount, setTotalCount] = useState(0);
  const DEBOUNCE_DELAY = 500; // milliseconds
  const ITEMS_PER_PAGE = 10;

  const { filteredData, filters, setFilter, clearFilter } = useClientFilter(getAllCustomer);
  const pageCount = Math.ceil(totalCount / ITEMS_PER_PAGE);

  const [addCustomer, setAddCustomer] = useState({
    name: "",
    mobile: "",
    email: "",
    address: {
      coordinates: [],
      type: "Point",
      streetAddress: "",
    },
    status: "active",
    company: {
      companyId: "",
      companyName: "",
    },
    additionalInfo: [],
    _id: "",
  });
  const removeChild = (index: number) => {
    setAddCustomer((prev) => ({
      ...prev,
      additionalInfo: prev.additionalInfo.filter((_, i) => i !== index),
    }));
  };
  const [openDialog, setOpenDialog] = useState(false);
  const [deleteId, setDeleteId] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [getCurrentUser, setCurrentUser] = useState<any>(null);

  // const openModal = () => setShowModal(true);
  const [selectedCustomerId, setSelectedCustomerId] = useState<
    string | undefined
  >("");
  const tenantConfig = getTenantConfigFromStorage();
  const parentLabel = tenantConfig.labels.parent;
  const schoolLabel = tenantConfig.labels.school;
  const childLabel = tenantConfig.labels.child;
  const canAddChild = tenantConfig.features.canAddChild;
  // const closeModal = () => setShowModal(false);

  const openModal = (customerId: string) => {
    setSelectedCustomerId(customerId);
    setShowModal(true);
  };
  useEffect(() => {
    const fetchUser = async () => {
      const userData = localStorage.getItem("user");
      if (userData) {
        setCurrentUser(JSON.parse(userData));
      }
    };
    fetchUser();
  }, []);
  const handleCloseModal = () => {
    setSelectedCustomerId("");
    setShowModal(false);
  };
  const getAllCustomers = async () => {
    try {
      const response = await dispatch(
        fetchCustomer(page, ITEMS_PER_PAGE, search, status, "")
      );
      if (
        response &&
        response?.data &&
        response?.data?.data &&
        response?.data?.data?.length &&
        response?.isSuccess
      ) {
        setAllCustomer(response?.data?.data);
        setTotalCount(response?.data?.totalCount);
      } else {
        setAllCustomer([]);
        setTotalCount(0);
      }
    } catch (error) {
      console.log(getAllCustomer);
      setAllCustomer([]);
      setTotalCount(0);
    } finally {
      setIsLoading(false); // Stop loader
    }
  };

  useEffect(() => {
    const handler = setTimeout(async () => {
      setIsLoading(true); // Start loader
      try {
        await getAllCustomers();
      } catch (error) {
        console.log(getAllCustomer);
        setAllCustomer([]);
        setTotalCount(0);
      } finally {
        setIsLoading(false); // Stop loader
      }
    }, DEBOUNCE_DELAY);
    return () => {
      clearTimeout(handler);
    };
  }, [search, page, dispatch, status]);

  // const handleCloseModal = () => {
  //   setShowModal(false);
  //   getAllCustomers();
  // };

  const gotoEdit = (id: string) => {
    navigate(`/edit-parent/${id}`);
  };
  const handleCopy = async (customer: any) => {
    if (!customer?.whatsappLink) return;

    try {
      // WhatsApp link me se text parameter nikaal lo
      const url = new URL(customer.whatsappLink);
      const text = url.searchParams.get("text");

      if (text) {
        await navigator.clipboard.writeText(text);
        toast.success("Copied to clipboard!");
      } else {
        toast.success("No text found in link!");
      }
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };
  const handledeleteCustomer = async (id: string) => {
    const response = await dispatch(deleteCustomer(id));
    if (response && response.isSuccess) {
      const newCustomer = getAllCustomer.filter((item: any) => item._id !== id);
      setAllCustomer(newCustomer);
    }
  };
  const handleDeleteClick = (id: string) => {
    setDeleteId(id);
    setOpenDialog(true);
  };

  const confirmDelete = async () => {
    if (deleteId) {
      await handledeleteCustomer(deleteId);
    }
    setOpenDialog(false);
    setDeleteId(null);
  };
  const navigateToaddcustomer = () => {
    navigate("/add-parent");
  };

  return (
    <>
      <ToastContainer />
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <div className="parents-header">
          <div className="d-flex flex-column">
            <h2 style={{ color: "#0f172a", fontWeight: "700", fontSize: "24px", margin: "0", fontFamily: "sans-serif" }}>
              {parentLabel}s Management
            </h2>
            <p style={{ color: "#64748b", fontSize: "14px", margin: "4px 0 0 0", fontWeight: "400" }}>
              View and organize {parentLabel}s
            </p>
          </div>
          {getCurrentUser && getCurrentUser.role === "admin" && getCurrentUser.role !== "superAdmin" && (
            <button className="add-parent-btn" onClick={navigateToaddcustomer}>
              <AddIcon />
              Add New {parentLabel}
            </button>
          )}
        </div>

        <Paper sx={{ padding: 2, marginTop: "20px", flex: 1, display: "flex", flexDirection: "column", overflow: "hidden" }}>
          <div style={{ flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }}>
            <div className="my-2 search-box justify-content-between align-items-baseline" style={{ flexShrink: 0 }}>
              <div className="search-wrapper">
                <IoSearchOutline className="search-icon" />
                <input
                  placeholder={`Type ${parentLabel} Name You Want Search`}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div>

              <select
                onChange={(e) => setStatus(e.target.value)}
                className="form-select"
                defaultValue=""
                style={{
                  width: "max-content",
                  height: "42px",
                  marginBottom: "15px",
                }}
                aria-label="Default select example"
              >
                <option value="">
                  All
                </option>
                <option value="active">Active</option>
                <option value="inActive">Inactive</option>
              </select>
            </div>
            <div style={{ flex: 1, overflow: "auto" }}>
              <Table className="table px-0">
                <TableHead className="th p-0">
                  <TableRow className="table-h-row">
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      S.No
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      {parentLabel}s
                      <FilterPopover column="name" filterType="text" currentValue={filters.name || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Email
                      <FilterPopover column="email" filterType="text" currentValue={filters.email || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      {schoolLabel}
                      <FilterPopover column="company.companyName" filterType="text" currentValue={filters["company.companyName"] || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    {canAddChild && (
                      <TableCell
                        className="px-1 py-2 text-start text-secondary"
                        style={{
                          fontSize: "18px",
                          backgroundColor: "#f9fafb",
                          fontWeight: 500,
                        }}
                      >
                        {childLabel}s
                        <FilterPopover column="additionalInfo" filterType="text" currentValue={filters.additionalInfo || ""} onFilterChange={setFilter} onClear={clearFilter} />
                      </TableCell>
                    )}
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Location
                      <FilterPopover column="address.streetAddress" filterType="text" currentValue={filters["address.streetAddress"] || ""} onFilterChange={setFilter} onClear={clearFilter} />
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Send Code
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Copy{" "}
                    </TableCell>
                    <TableCell
                      className="px-1 py-2 text-start text-secondary"
                      style={{
                        fontSize: "18px",
                        backgroundColor: "#f9fafb",
                        fontWeight: 500,
                      }}
                    >
                      Status
                    </TableCell>
                    {getCurrentUser &&
                      getCurrentUser.role === "admin" && getCurrentUser.role !== "superAdmin" && (
                        <TableCell
                          className="px-1 py-2 text-start text-secondary"
                          style={{
                            fontSize: "18px",
                            backgroundColor: "#f9fafb",
                            fontWeight: 500,
                          }}
                        >
                          Action
                        </TableCell>
                      )}
                  </TableRow>
                </TableHead>

                <TableBody className="tb">
                {isLoading ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Loader />
                    </TableCell>
                  </TableRow>
                ) : (
                  <>
                    {filteredData.map((customer: any, index) => (
                      <TableRow key={index} className="t-row">
                        <TableCell>
                          {" "}
                          {(page - 1) * ITEMS_PER_PAGE + index + 1}
                        </TableCell>
                        <TableCell>
                          <div className="d-flex multipleCon">
                            <img
                              src={customer.photoUrl}
                              className="img-fluid rounded-pill"
                              style={{ height: "40px" }}
                            />

                            <div
                              className="d-flex flex-column"
                              style={{ marginLeft: "5px" }}
                            >
                              <span className="fw-semibold">
                                {customer.name || "--"}
                              </span>
                              <span className="text-muted m-0 CusId">
                                ID # {customer.id}
                              </span>
                            </div>
                          </div>
                        </TableCell>
                        {/* <TableCell>{customer.mobile || "--"}</TableCell> */}
                        <TableCell>{customer.email || "--"}</TableCell>
                        <TableCell>
                          {customer.company.companyName || "--"}
                        </TableCell>
                        {canAddChild && (
                          <TableCell>
                            {customer?.additionalInfo?.length || 0}
                          </TableCell>
                        )}
                        <TableCell>
                          <span title={customer.address?.streetAddress}>
                            {customer.address?.streetAddress
                              ? customer.address.streetAddress.length > 10
                                ? customer.address.streetAddress.slice(0, 25) +
                                  "..."
                                : customer.address.streetAddress
                              : "--"}
                          </span>
                        </TableCell>

                        {/* <TableCell>{customer.code || "--"}</TableCell> */}
                        <TableCell>
                          <Button
                            variant="contained"
                            endIcon={<SendIcon style={{ fontSize: "15px" }} />}
                            style={{
                              width: "120px",
                              height: "auto",
                              background: "#4285F4",
                              color: "#fff",
                              fontWeight: "500",
                              fontSize: "13px",
                              borderRadius: "12px",
                              textTransform: "none",
                            }}
                            component="a"
                            href={customer.whatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Send Code
                          </Button>
                        </TableCell>
                        <TableCell>
                          <Button
                            variant="contained"
                            endIcon={<FaRegCopy style={{ fontSize: "15px" }} />}
                            style={{
                              width: "120px",
                              height: "auto",
                              background: "#f3f4f6",
                              color: "#374151",
                              fontWeight: "500",
                              fontSize: "13px",
                              borderRadius: "12px",
                              textTransform: "none",
                            }}
                            component="a"
                            onClick={() => handleCopy(customer)}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Copy
                          </Button>
                        </TableCell>
                        <TableCell>
                          {/* <Chip label={customer.driver || '--'} color="success" size="small" /> */}
                          <Chip
                            style={{
                              display: "inline-flex",
                              padding: "0.25rem 0.5rem",
                              fontSize: "0.75rem",
                              lineHeight: "1rem",
                              fontWeight: 600,
                              borderRadius: "9999px",
                              backgroundColor: "#D1FAE5",
                              color: "#065F46",
                            }}
                            label={customer.status || "--"}
                          />
                        </TableCell>
                        {getCurrentUser &&
                          getCurrentUser.role !== "schoolAdmin" && getCurrentUser.role !== "superAdmin" && (
                            <TableCell>
                              <div className="d-flex">
                                <IconButton className="icon-btn">
                                  <EditIcon
                                    onClick={() => gotoEdit(customer._id)}
                                    style={{ color: "primary" }}
                                    className="icons"
                                  />
                                </IconButton>
                                <IconButton className="icon-btn-red">
                                  <MdDelete
                                    onClick={() =>
                                      handleDeleteClick(customer._id)
                                    }
                                    style={{ color: "red" }}
                                    className="icons"
                                  />
                                </IconButton>
                                <div>
                                  {/* Button */}
                                  {canAddChild && (
                                    <button
                                      className="AddChild"
                                      onClick={() => openModal(customer._id)}
                                    >
                                      Add {childLabel}
                                    </button>
                                  )}

                                  {/* Modal */}
                                  {showModal &&
                                    selectedCustomerId === customer._id && (
                                      <div className="modal-overlay">
                                        <div className="modal-box">
                                          <div className="ModalHeaeder">
                                            <h1>Assign {childLabel}</h1>
                                            {/* <AiOutlineClose
                                        style={{
                                          cursor: "pointer",
                                          fontSize: "24px",
                                        }}
                                      
                                      /> */}
                                          </div>
                                          <AddChild
                                            onClose={handleCloseModal}
                                            customerId={selectedCustomerId}
                                          />
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                            </TableCell>
                          )}
                      </TableRow>
                    ))}
                    <ConfirmDialog
                      open={openDialog}
                      onClose={() => setOpenDialog(false)}
                      onConfirm={confirmDelete}
                    />

                    {filteredData.length === 0 && (
                      <TableRow>
                        <TableCell colSpan={6} align="center">
                          No {parentLabel} Found.
                        </TableCell>
                      </TableRow>
                    )}
                  </>
                )}
                </TableBody>
              </Table>
            </div>
          </div>
          <nav style={{ flexShrink: 0 }}>
            <ul className="pagination  mt-3 justify-content-center">
              <li className={`page-item ${page === 1 && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => setPage((p) => Math.max(p - 1, 1))}
                >
                  Previous
                </button>
              </li>

              {Array.from({ length: Math.min(5, pageCount) }, (_, i) => (
                <li
                  key={i + 1}
                  className={`page-item ${page === i + 1 && "active"}`}
                >
                  <button className="page-link" onClick={() => setPage(i + 1)}>
                    {i + 1}
                  </button>
                </li>
              ))}

              {pageCount > 5 && (
                <>
                  <li className="page-item disabled">
                    <span className="page-link">...</span>
                  </li>
                  <li className="page-item">
                    <button
                      className="page-link"
                      onClick={() => setPage(pageCount)}
                    >
                      {pageCount}
                    </button>
                  </li>
                </>
              )}

              <li className={`page-item ${page === pageCount && "disabled"}`}>
                <button
                  className="page-link"
                  onClick={() => setPage((p) => Math.min(p + 1, pageCount))}
                >
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </Paper>
      </div>
    </>
  );
};
export default CustomerList;

